import { Difficulty, Topic } from "../types/Problem";

export function showDifficultyIt(difficulty: Difficulty) {
	const difficultyEnIt = {
		"very-easy": "Molto facile",
		easy: "Facile",
		medium: "Medio",
		hard: "Difficile",
		"very-hard": "Estremo",
	};

	if (difficultyEnIt[difficulty]) {
		return difficultyEnIt[difficulty];
	} else {
		return "";
	}
}

export function showTopicIt(topic: Topic) {
	const topicEnIt = {
		algebra: "Algebra",
		"number-theory": "Teoria dei numeri",
		combinatorics: "Combinatoria e logica",
		geometry: "Geometria",
	};

	if (topicEnIt[topic]) {
		return topicEnIt[topic];
	} else {
		return "";
	}
}
